import type { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './CellLines.module.scss';

interface CellLinesProps {
    first: ReactNode;
    /** Nothing renders for null, and the first line stays centred in the row. */
    second?: ReactNode;
    firstTitle?: string;
    secondTitle?: string;
    /** Tabular numerals, so times and addresses line up down the column. */
    numeric?: boolean;
}

// Text needs its own box to get an ellipsis: a line is a flex row, and a bare text
// node in one would be clipped without it.
function lineContent(content: ReactNode): ReactNode {
    return typeof content === 'string' ? <span className={styles.text}>{content}</span> : content;
}

/** The two single-line texts every cell shows, each cut with an ellipsis. */
export default function CellLines(props: CellLinesProps) {
    const { first, second = null, firstTitle, secondTitle, numeric = false } = props;
    return (
        <div className={classNames(styles.lines, { [styles.numeric]: numeric })}>
            <div className={styles.first} title={firstTitle}>
                {lineContent(first)}
            </div>
            {second !== null && second !== '' ? (
                <div className={styles.second} title={secondTitle}>
                    {lineContent(second)}
                </div>
            ) : null}
        </div>
    );
}
